import { render, staticRenderFns } from "./SuperTag.vue?vue&type=template&id=01b9fac2&"
import script from "./SuperTag.vue?vue&type=script&lang=js&"
export * from "./SuperTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports